module.exports = __webpack_public_path__ + "img/ironclad.b60238fd.png";